import { defineMessages } from 'react-intl';

export default defineMessages({
  selectAccount: {
    defaultMessage: 'Select Account',
    id: 'BGNBh/',
    description: 'Insights > Reports > Shipping Manifest > Select Account',
  },
});
